const SOURCES = {
  census: { label: 'U.S. Census · Ecommerce', url: 'https://www.census.gov/retail/ecommerce.html' },
  kdp: { label: 'Amazon KDP · Publishing', url: 'https://kdp.amazon.com/en_US/help/topic/GHKDSCW2KQ3K4UU4/' },
  fba: { label: 'Amazon · Fulfillment by Amazon', url: 'https://sell.amazon.com/fulfillment-by-amazon' },
};

const KNOWLEDGE = [
  {
    id: 'overview',
    title: 'Aether Systems overview',
    keywords: ['aether systems', 'company', 'business', 'what do you do', 'about', 'overview', 'capabilities', 'mission'],
    answer: 'Aether Systems connects four customer-facing divisions: Aether Software, Aether Mercantile, Aether Customers, and Aether SocMe. Together they provide software, commerce, marketing, customer experience, social media, content, and publishing capabilities through one guided point of contact.',
  },
  {
    id: 'latest',
    title: 'Latest public website update',
    keywords: ['latest', 'recent update', 'new', 'website update', 'what is new', 'site update', 'progress'],
    answer: 'The latest public update introduces this guided digital lobby, an interactive ARIYA concierge, a blue division briefing menu, and dedicated pages for every customer-facing Aether division. Visitors can now compare services without seeing internal operating information.',
  },
  {
    id: 'software',
    title: 'Aether Software',
    keywords: ['aether software', 'software', 'engineering', 'app', 'application', 'development', 'automation', 'integration', 'license', 'licensing'],
    answer: 'Aether Software provides application engineering, workflow automation, AI integration, product architecture, deployment, licensing support, and ongoing technical care. For the complete service overview, open Aether Software from the division menu below the lobby.',
  },
  {
    id: 'mercantile',
    title: 'Aether Mercantile',
    keywords: ['aether mercantile', 'mercantile', 'product', 'products', 'ecommerce', 'commerce', 'shop', 'store', 'pod', 'print on demand', 'fba', 'amazon', 'kdp', 'kindle', 'publishing', 'supplier', 'sourcing'],
    answer: 'Aether Mercantile focuses on products and commerce across ecommerce, print on demand, marketplaces, publishing, catalog development, and product research. For offerings and working details, open Aether Mercantile from the division menu below the lobby.',
  },
  {
    id: 'customers',
    title: 'Aether Customers',
    keywords: ['aether customers', 'customer', 'support', 'service', 'marketing', 'campaign', 'brand', 'sales', 'crm', 'customer care'],
    answer: 'Aether Customers provides brand and campaign support, sales and CRM systems, customer care design, and service operations that help businesses attract, understand, and support their customers. Open Aether Customers from the division menu below the lobby for full details.',
  },
  {
    id: 'socme',
    title: 'Aether SocMe',
    keywords: ['aether socme', 'socme', 'social media', 'social', 'content', 'trend', 'audience', 'post', 'creator', 'community'],
    answer: 'Aether SocMe provides social strategy, content planning, audience research, campaign coordination, community support, and performance insights. Open Aether SocMe from the division menu below the lobby to see the complete service overview.',
  },
  {
    id: 'products',
    title: 'Products and product development',
    keywords: ['product', 'products', 'what products', 'catalog', 'buy', 'shop'],
    answer: 'Aether’s product work is led by Aether Mercantile for physical, marketplace, print-on-demand, and publishing products, while Aether Software leads digital products and applications. Use the division menu below the lobby to open the area that matches what you are looking for.',
  },
  {
    id: 'ariya',
    title: 'ARIYA',
    keywords: ['ariya', 'avatar', 'concierge', 'ai assistant', 'artificial intelligence', 'who are you'],
    answer: 'I’m ARIYA, the public Aether Systems concierge. I can explain customer-facing divisions, products, services, and relevant markets, then direct you to the right division page for more detail.',
  },
  {
    id: 'routing',
    title: 'Find the right division',
    keywords: ['which division', 'find my division', 'who should i speak', 'where do i go', 'help me choose', 'right division'],
    answer: 'Choose Aether Software for applications and automation; Aether Mercantile for products, ecommerce, marketplaces, or publishing; Aether Customers for marketing, sales, CRM, or customer care; and Aether SocMe for social media, content, audience, or community work. The division links below the lobby provide complete details.',
  },
  {
    id: 'market-ecommerce',
    title: 'Ecommerce market',
    keywords: ['market', 'market size', 'ecommerce market', 'online retail', 'retail sales', 'growth', 'trend', 'opportunity'],
    answer: 'The U.S. Census Bureau reported seasonally adjusted U.S. retail ecommerce sales of $340.2 billion in Q2 2026, up 3.8% from Q1 and 12.2% from Q2 2025. Aether Mercantile evaluates opportunities against demand, margin, return exposure, and channel fit.',
    sources: [SOURCES.census],
  },
  {
    id: 'market-kdp',
    title: 'KDP publishing',
    keywords: ['kdp', 'kindle direct publishing', 'book', 'books', 'ebook', 'paperback', 'hardcover', 'publishing market'],
    answer: 'Amazon KDP supports ebooks, paperbacks, and hardcovers, with print production and shipping available on demand for print formats. Aether Mercantile’s publishing work emphasizes original rights-cleared content, correct files, proof review, metadata, pricing, and honest promotion.',
    sources: [SOURCES.kdp],
  },
  {
    id: 'market-fba',
    title: 'Amazon FBA',
    keywords: ['fba', 'fulfillment by amazon', 'amazon seller', 'inventory', 'fulfillment', 'amazon market'],
    answer: 'Fulfillment by Amazon can handle storage, pick-and-pack, shipping, customer service, and returns. Aether Mercantile evaluates FBA work through landed cost, fees, storage exposure, sell-through, return rate, compliance, and cash conversion.',
    sources: [SOURCES.fba],
  },
  {
    id: 'services',
    title: 'Services and engagement',
    keywords: ['service', 'services', 'hire', 'work with', 'project', 'consulting', 'available', 'offer', 'contact', 'quote', 'pricing', 'price', 'cost'],
    answer: 'Aether offers software and automation, product and commerce work, marketing and customer experience, and social media and content services. Select a division in the blue briefing menu for a quick explanation, then use the division links below the lobby for full details. Formal scope and pricing begin with a reviewed project conversation.',
  },
  {
    id: 'privacy',
    title: 'Public information boundary',
    keywords: ['privacy', 'private', 'internal', 'confidential', 'security policy', 'operational details'],
    answer: 'This concierge is limited to customer-facing information about Aether divisions, products, services, and public market context. Internal operating metrics, infrastructure details, private records, and administrative controls are not displayed here.',
  },
];

const STOP_WORDS = new Set(['a', 'an', 'and', 'are', 'can', 'do', 'does', 'for', 'how', 'i', 'in', 'is', 'it', 'me', 'of', 'on', 'our', 'tell', 'the', 'to', 'we', 'what', 'with', 'you', 'your']);
const PRIVATE_QUERY = /\b(how many agents|agent count|core tests?|service health|node count|how many nodes|internal architecture|internal status|private operations?|owner records?|server (?:details|address|host|topology)|server credentials?|api key)\b/i;

function tokens(value) {
  return String(value).toLowerCase().replace(/[^a-z0-9+ ]/g, ' ').split(/\s+/).filter((token) => token.length > 1 && !STOP_WORDS.has(token));
}

function scoreEntry(query, entry, previousTopic) {
  const lowered = query.toLowerCase();
  const queryTokens = tokens(query);
  let score = entry.id === previousTopic ? 0.75 : 0;
  for (const keyword of entry.keywords) if (lowered.includes(keyword)) score += keyword.includes(' ') ? 5 : 2.4;
  const corpus = new Set(tokens(`${entry.title} ${entry.answer} ${entry.keywords.join(' ')}`));
  for (const token of queryTokens) if (corpus.has(token)) score += 1;
  return score;
}

function directIntent(query) {
  const q = query.trim().toLowerCase();
  if (PRIVATE_QUERY.test(q)) return { text: 'I can help with Aether’s public products, services, divisions, and market information. Internal operating metrics and infrastructure details are not part of the public website.', topic: 'privacy', sources: [] };
  if (/^(hi|hello|hey|good morning|good afternoon|good evening)\b/.test(q)) return { text: 'Hello, and welcome to Aether Systems. Select a division from the blue menu for a quick briefing, or tell me what you want to build, sell, promote, or improve.', topic: 'ariya', sources: [] };
  if (/\b(thank you|thanks|appreciate it)\b/.test(q)) return { text: 'You’re welcome. Use the division menu below the lobby whenever you are ready for more detail.', topic: 'overview', sources: [] };
  return null;
}

export function answerFromKnowledge(query, context = {}) {
  const direct = directIntent(query);
  if (direct) return direct;
  const ranked = KNOWLEDGE.map((entry) => ({ entry, score: scoreEntry(query, entry, context.previousTopic) })).sort((a, b) => b.score - a.score);
  const best = ranked[0];
  if (!best || best.score < 1.4) return { text: 'I can help with Aether Software, Aether Mercantile, Aether Customers, Aether SocMe, our public products and services, or relevant markets. Which area best matches your goal?', topic: context.previousTopic || 'overview', sources: [] };
  return { text: best.entry.answer, topic: best.entry.id, sources: best.entry.sources || [] };
}

export function answerForTopic(topic) {
  const match = KNOWLEDGE.find((entry) => entry.title.toLowerCase().includes(topic.toLowerCase()) || entry.id === topic.toLowerCase());
  return match ? { text: match.answer, topic: match.id, sources: match.sources || [] } : answerFromKnowledge(topic);
}
